export const FIESTA_IFRAME_MESSAGE_ACTIONS = {
  UNDO: 'UNDO',
  REDO: 'REDO',
  DEVICE_TYPE_CHANGE: 'DEVICE_TYPE_CHANGE',
  UNDO_REDO_AVAILABILITY: 'UNDO_REDO_AVAILABILITY',
  ASSET_UPLOAD_REQUEST: 'ASSET_UPLOAD_REQUEST',
  ASSET_UPLOAD_RESPONSE: 'ASSET_UPLOAD_RESPONSE',
};

export const FIESTA_WEB_BUILDER_ASSET_TYPE = 'webBuilderAsset';

export const VIEWPORT_DEVICES = {
  desktop: {
    name: 'desktop',
  },
  tablet: {
    name: 'tablet',
  },
  mobilePortrait: {
    name: 'mobilePortrait',
  },
};

export const TEMPLATE_CATEGORIES = {
  salsa_1: { id: 'salsa_1', title: 'Salsa 1' },
  salsa_2: { id: 'salsa_2', title: 'Salsa 2' },
  guac_chips: { id: 'guac_chips', title: 'Guac & Chips' },
  tortilla: { id: 'tortilla', title: 'Tortilla' },
};

// eslint-disable-next-line no-undef
export const WEB_BUILDER_URL = process.env.REACT_APP_WEB_BUILDER_URL || 'http://localhost:3001';
